import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useUpdateMissionInfo = () => {
	const { getStreamData } = useGetStreamData();

	const updateMissionInfo = useCallback(
		(prevState, stream) => {
			const mission = { ...prevState.mission };
			if (stream['/mission']) {
				const newMission = getStreamData(stream, '/mission');
				mission.mission = newMission.mission;
				mission.subMission = newMission.sub_mission;
			}
			return mission;
		},
		[getStreamData],
	);

	return { updateMissionInfo };
};
